var _defs, _g, _g2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitFromParkingLot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "parking-line"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(20,-4.5) rotate(270)",
    fontSize: 16,
    fontFamily: "Arial",
    opacity: 0.7,
    fill: "#FFF"
  }, "\r\n                P\r\n            "), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "                 M 0 0                  L 30 0                 M 30 -2                 L 30 2",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    id: "road-lines",
    d: "     M -100 0     L 120 0",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeDasharray: "12 10",
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 60,
    x: -100,
    y: -30,
    fill: "#3a4149"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#road-lines",
    transform: "translate(5,0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180) translate(0,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 160,
    x: -60,
    y: -80,
    fill: "#3a4149"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 150,
    x: -17.5,
    y: -100,
    fill: "#3a4149"
  }), /*#__PURE__*/React.createElement("react", {
    width: 100,
    height: 150,
    x: -100,
    y: -100,
    fill: "url(#parking-line-pattern)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,0)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,60)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M -50 -80 L -50 80",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-60)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,-20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,0)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,20)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,40)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#parking-line",
    transform: "translate(-50,60)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M -50 -80 L -50 80",
    strokeWidth: 0.6
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(-30,-4.5) rotate(270)",
    fontSize: 16,
    fontFamily: "Arial",
    opacity: 0.7,
    fill: "#FFF"
  }, "\r\n        P\r\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFromParkingLot);
export default __webpack_public_path__ + "static/media/exit-from-parking-lot.2b4160f24dc36e7684051e99210d1da3.svg";
export { ForwardRef as ReactComponent };